module.exports = __webpack_public_path__ + "img/socials_2.8d1522f8.png";